export const CUSTOMER_GUEST_MESSAGES = {
  LOGIN_SUCCESS: 'Login realizado com sucesso!',
  ACCOUNT_CREATED: 'Conta criada com sucesso!',
  CPF_NOT_FOUND: 'CPF not found, allowing user to continue without account',
  LOGIN_ERROR: 'Error during login',
  DEFAULT_ERROR: 'Confirme os dados e tente novamente',
  PHONE_MISMATCH: 'O telefone informado não corresponde ao cadastro.',
  STATUS_CHECK_FAILED:
    'Não foi possível verificar este CPF agora. Tente novamente em instantes.',
} as const;

export const RECOVERY_MESSAGES = {
  CPF_NOT_FOUND: 'CPF não encontrado em nossa base.',
  KYC_TITLE: 'Verificação de identidade',
  KYC_DESCRIPTION: 'Para sua segurança, precisamos verificar sua identidade.',
  KYC_VALIDATING: 'Aguarde enquanto verificamos sua identidade...',
  KYC_FAILED: 'Não foi possível verificar sua identidade.',
  KYC_TIMEOUT: 'O tempo de verificação expirou.',
  PHONE_UPDATED: 'Telefone atualizado com sucesso!',
  PHONE_UPDATE_ERROR: 'Erro ao atualizar o telefone.',
  PHONE_ALREADY_REGISTERED: 'O novo telefone deve ser diferente do telefone atual.',
} as const;
